import React, { useEffect, useRef, useState } from 'react'
import Talk from 'talkjs'

import GroupChatView from '../component/GroupChatView'
import { CONFIG } from '../../../../Config/config'
import useGraphQLFetch from '../../../../Utils/Hooks/useGraphQLFetch'
import { getChannels } from '../../gql'
import {
  ROLE_ADMIN,
  TALK_JS_CHAT_TYPES_MAP,
} from '../../../../shared/constants'
import { notificationHandler } from '../../utils'

const { appID } = CONFIG.TALKJS

const GroupChat = ({ user, setNotificationConversation, setViewType }) => {
  let ref = useRef(null)
  const [conversationId, setConversationId] = useState(null)
  const [channels, setChannels] = useState([])
  const [activeIndex, setActiveIndex] = useState(null)
  const { data, isLoaded, refetch } = useGraphQLFetch({
    fetchFn: getChannels,
    defaultFetchArgs: null,
    mapResponse: data => data.chatChannels.nodes,
  })

  useEffect(() => {
    if (isLoaded) {
      const sortedInAlphabetical = data.sort((a, b) =>
        a.subject.localeCompare(b.subject),
      )
      setChannels(sortedInAlphabetical)
    }
  }, [isLoaded])

  const initChat = async ({ conversationId, ref, user }) => {
    await Talk.ready

    const me = new Talk.User(user.id)
    const session = new Talk.Session({
      appId: appID,
      me,
    })
    const conversation = session.getOrCreateConversation(conversationId)
    const inbox = session.createInbox()
    const chatbox = session.createChatbox()

    const isCountryChat = String(conversationId).includes(
      TALK_JS_CHAT_TYPES_MAP.COUNTRY,
    )

    chatbox.select(conversation, { asGuest: true })
    if (isCountryChat) {
      chatbox.messageField.setVisible(user.role === ROLE_ADMIN)
    }

    session.onDesktopNotificationClicked(data => {
      setNotificationConversation(data.conversation.id)
      notificationHandler({ data, inbox, session, setViewType })
    })
    chatbox.onSendMessage(refetch)
    chatbox.mount(ref)
  }

  useEffect(() => {
    try {
      if (conversationId && user.id) {
        initChat({
          conversationId,
          ref,
          user,
        })
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('initChat_ERROR', { error })
    }
  }, [conversationId])

  const setRef = value => {
    ref = value
  }

  return (
    <GroupChatView
      channels={channels}
      setConversationId={(id, index) => {
        setConversationId(id)
        setActiveIndex(index)
      }}
      setRef={setRef}
      activeIndex={activeIndex}
      isLoaded={isLoaded}
    />
  )
}

export default GroupChat
